import { NextSeo } from 'next-seo';
import CallToActions from '@apps/components/ico-landing/CallToActions';
import React from 'react';
import FeaturesCard from '@apps/components/crypto/features-card';
import Features from '@apps/components/cryto-trading/Features';
import CardDrawer from '@apps/components/card-drawer/card-drawer';
import Hero_10 from '@apps/components/hero/hero_10';
import Services from '@apps/components/services/services';
import Benifits from '@apps/components/dao/Benifits';

const DappDevelopment = () => {
  const metaTitle = "dApp Development - Alchemis";
  const metaDesc = `By developing a decentralized app, your business can achieve a level of transparency, security, and independence unmatched by traditional applications.`;
  const metaImg = `/images/meta/services-dapp.png`;
  const content = {
    title: "Decentralized App: A part of future digital innovation",
    descriptions: `By developing a decentralized app, your business can achieve a level of transparency, security, and independence unmatched by traditional applications.`,
    headImage: '/images/alchemis-lab/dapp.png',
    animationImage: '/images/alchemis-lab/dapp-side.png',
    backgroundImage: '/images/alchemis-lab/background.png',
  };
  const descList = {
    title: 'The Dawn of Decentralization: Why Decentralized App Development?',
    subTitle: 'dApps, inherently integrated with blockchain technology, guarantee absolute security and resistance to censorship. Transactions and data exchanges become transparent and immutable, fostering trust among users. Furthermore, dApps are open source, fostering a sense of community ownership and engagement.',
    data: [
      {
        id: 1,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='21' viewBox='0 0 16 21' fill='none'>
              <g clipPath='url(#clip0_384_45245)'>
                <path
                  d='M7.99416 0.5C3.69679 0.5 0.198839 3.79826 0.198839 7.8503H1.98434C1.98434 4.72805 4.67881 2.18739 7.99416 2.18739C11.3095 2.18739 13.9999 4.72805 13.9999 7.8503C13.9999 9.88971 12.8353 12.8972 12.0075 14.3856C11.2567 15.7324 10.3843 16.7962 9.4185 17.5461C8.33097 18.3879 7.1217 18.8164 5.82315 18.8164C3.59494 18.8141 1.78955 17.1103 1.78955 15.0093H0C0 18.0397 2.61332 20.5 5.82315 20.5C9.03299 20.5 11.6463 18.6557 13.5901 15.1662C15.2051 12.2735 15.7895 9.2048 15.7895 7.8503C15.7895 3.79826 12.2915 0.5 7.99416 0.5Z'
                  fill='#8358FF' />
                <path
                  d='M8.45737 14.0031C7.93795 14.4087 7.39013 14.6038 6.77738 14.6038V16.2874C7.80404 16.2874 8.74954 15.9583 9.5936 15.3079C10.255 14.7913 10.8434 14.0835 11.3345 13.1996C12.146 11.7456 12.5681 10.0238 12.5681 9.07103C12.5681 6.66812 10.4945 4.71289 7.95013 4.71289C5.39849 4.71519 3.33056 6.66506 3.32812 9.07103V9.91281H4.22087C4.55038 9.91281 4.81739 10.1642 4.8178 10.4749C4.8178 10.7856 4.55119 11.0374 4.22168 11.0377H4.22087V12.7213C5.53646 12.7248 6.60613 11.7223 6.60979 10.4818C6.61263 9.59332 6.05953 8.78674 5.19884 8.42439C5.57055 6.99144 7.10364 6.11446 8.62334 6.46495C9.89551 6.75842 10.7887 7.83629 10.7826 9.07103C10.7826 9.5608 10.531 11.0224 9.75186 12.419C9.37041 13.1001 8.93621 13.6358 8.45737 14.0031Z'
                  fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45245'>
                  <rect width='15.7895' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Data Security',
        text: `dApps ensure tamper-proof and secure data management.`
      },
      {
        id: 2,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='22' height='21' viewBox='0 0 22 21' fill='none'>
              <g clipPath='url(#clip0_384_45255)'>
                <path
                  d='M14.0302 14.5301V0.600586H0V19.316H9.21914L14.0302 14.5301ZM9.67254 16.7467V14.9835H11.4358L9.67254 16.7467ZM1.51134 2.11192H12.5189V13.4721H8.16121V17.8046H1.51134V2.11192Z'
                  fill='#8358FF' />
                <path
                  d='M21.1077 15.8149V0.5H16.0195V15.8149L18.5636 20.5L21.1077 15.8149ZM17.9591 16.1927H19.1681L18.5636 17.3262L17.9591 16.1927ZM17.5309 14.6814V4.3539H19.5964V14.6814H17.5309ZM19.5964 2.01134V2.84257H17.5309V2.01134H19.5964Z'
                  fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45255'>
                  <rect width='21.1083' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Transparency',
        text: `Every transaction and data exchange is traceable and auditable.`
      },
      {
        id: 3,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21' fill='none'>
              <g clipPath='url(#clip0_384_45265)'>
                <path
                  d='M18.0565 20.5H1.94354C0.871819 20.5 0 19.6282 0 18.5565V2.44354C0 1.37182 0.871819 0.5 1.94354 0.5H18.0588C19.1305 0.5 20.0023 1.37182 20.0023 2.44354V18.5627C19.9979 19.631 19.1249 20.5002 18.0565 20.5002V20.5ZM1.94354 2.35099C1.89519 2.35099 1.85099 2.39519 1.85099 2.44354V18.5565C1.85099 18.6048 1.89519 18.649 1.94354 18.649H18.0565C18.1055 18.649 18.1506 18.6048 18.1513 18.5558V2.44354C18.1513 2.39519 18.1071 2.35099 18.0588 2.35099H1.94354Z'
                  fill='#8358FF' />
                <path d='M19.0771 3.89062H0.925781V5.74162H19.0771V3.89062Z' fill='#8358FF' />
                <path
                  d='M7.69995 15.7557L3.89453 12.3476L7.69995 8.93945L8.93502 10.3184L6.66917 12.3476L8.93502 14.3768L7.69995 15.7557Z'
                  fill='#8358FF' />
                <path
                  d='M12.3015 15.7557L11.0664 14.3768L13.3323 12.3476L11.0664 10.3184L12.3015 8.93945L16.1069 12.3476L12.3015 15.7557Z'
                  fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45265'>
                  <rect width='20.0023' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Censorship Resistance',
        text: `No single entity can control or manipulate a dApp.`
      },
      {
        id: 4,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='21' viewBox='0 0 20 21' fill='none'>
              <g clipPath='url(#clip0_384_45277)'>
                <path
                  d='M8.17107 4.55608C7.44053 4.21322 6.64726 4.02947 5.84053 4.01827C3.11336 3.89053 0.796275 5.99698 0.664062 8.72415V9.39642L4.54081 9.57569C3.97611 10.7746 3.56378 12.0407 3.30832 13.3404C3.12905 14.2143 3.80132 15.2676 4.496 15.9622C4.83213 16.2984 5.66126 17.0379 6.49039 17.0379H6.73689C8.11056 16.7959 9.44614 16.3656 10.7033 15.7606L10.8825 19.6597H11.5548C14.282 19.5275 16.3884 17.2104 16.2607 14.4833C16.2517 13.6833 16.068 12.8967 15.7229 12.1751C18.412 9.28437 19.8237 5.54208 19.8237 1.17233V0.500058H19.1515C14.7817 0.45524 11.0394 1.86701 8.17107 4.55608ZM18.2551 3.99586C17.361 3.62835 16.6506 2.91799 16.2831 2.02387C17.0092 1.90286 17.7442 1.82667 18.4792 1.79978C18.4523 2.53479 18.3761 3.26981 18.2551 3.99586ZM12.1823 13.3628L11.5548 13.7662C9.04726 13.188 7.09095 11.2317 6.5128 8.72415L6.89375 8.14151C8.88815 5.16112 11.622 3.18913 14.961 2.31518C15.4495 3.72247 16.5565 4.82947 17.9638 5.31799C17.1033 8.62555 15.0439 11.4939 12.1823 13.3628ZM2.09824 8.11911C2.51952 6.44964 4.0523 5.30006 5.77331 5.3628C6.24389 5.37849 6.71 5.45468 7.16266 5.58689C6.65622 6.15832 6.19235 6.7656 5.77331 7.40202C5.57387 7.67989 5.39235 7.97121 5.23549 8.27597L2.09824 8.11911ZM6.49039 15.6933C6.35594 15.7157 5.84053 15.4692 5.30272 14.8866C4.7649 14.304 4.58563 13.7438 4.60804 13.6093C4.83437 12.4956 5.18619 11.4132 5.66126 10.3824C6.47695 12.2917 7.99179 13.8155 9.89655 14.6401C8.80524 15.1174 7.66238 15.4715 6.49039 15.6933ZM12.1599 18.1807L12.0254 15.2452H12.0702L12.115 14.9987C12.384 14.8194 12.6753 14.6625 12.9442 14.4608C13.5582 14.0552 14.1431 13.6071 14.6921 13.1163C14.8355 13.5667 14.9117 14.0351 14.9162 14.5057C14.9879 16.2312 13.8361 17.7662 12.1599 18.1807Z'
                  fill='#8358FF' />
                <path
                  d='M14.894 5.38528C13.7175 4.20881 11.8127 4.20881 10.6363 5.38528C9.45979 6.56175 9.45979 8.46652 10.6363 9.64299C11.7881 10.8195 13.6749 10.8374 14.8514 9.68556C14.8648 9.67212 14.8805 9.65643 14.894 9.64299C16.0704 8.49116 16.0884 6.60433 14.9365 5.42786C14.9231 5.41441 14.9074 5.39873 14.894 5.38528ZM13.9528 8.70181C13.2738 9.33374 12.2094 9.29789 11.5774 8.6189C10.9769 7.97352 10.9769 6.97184 11.5774 6.32646C12.234 5.67212 13.2962 5.67212 13.9528 6.32646C14.6071 6.98304 14.6071 8.04523 13.9528 8.70181Z'
                  fill='#8358FF' />
                <path d='M3.58692 15.7529L0.148438 19.1914L1.09917 20.1421L4.53765 16.7037L3.58692 15.7529Z'
                      fill='#8358FF' />
                <path d='M5.22096 17.4275L3.09766 19.5508L4.04839 20.5015L6.17169 18.3782L5.22096 17.4275Z'
                      fill='#8358FF' />
                <path d='M1.90146 14.1073L0 16.0088L0.950732 16.9595L2.8522 15.0581L1.90146 14.1073Z' fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45277'>
                  <rect width='19.8252' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Community Ownership',
        text: `The power of governance is distributed among the users.`
      },
    ]
  };
  const features_data ={
    data: [
      {
        id: 1,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='21' viewBox='0 0 16 21' fill='none'>
              <g clipPath='url(#clip0_384_45245)'>
                <path
                  d='M7.99416 0.5C3.69679 0.5 0.198839 3.79826 0.198839 7.8503H1.98434C1.98434 4.72805 4.67881 2.18739 7.99416 2.18739C11.3095 2.18739 13.9999 4.72805 13.9999 7.8503C13.9999 9.88971 12.8353 12.8972 12.0075 14.3856C11.2567 15.7324 10.3843 16.7962 9.4185 17.5461C8.33097 18.3879 7.1217 18.8164 5.82315 18.8164C3.59494 18.8141 1.78955 17.1103 1.78955 15.0093H0C0 18.0397 2.61332 20.5 5.82315 20.5C9.03299 20.5 11.6463 18.6557 13.5901 15.1662C15.2051 12.2735 15.7895 9.2048 15.7895 7.8503C15.7895 3.79826 12.2915 0.5 7.99416 0.5Z'
                  fill='#8358FF' />
                <path
                  d='M8.45737 14.0031C7.93795 14.4087 7.39013 14.6038 6.77738 14.6038V16.2874C7.80404 16.2874 8.74954 15.9583 9.5936 15.3079C10.255 14.7913 10.8434 14.0835 11.3345 13.1996C12.146 11.7456 12.5681 10.0238 12.5681 9.07103C12.5681 6.66812 10.4945 4.71289 7.95013 4.71289C5.39849 4.71519 3.33056 6.66506 3.32812 9.07103V9.91281H4.22087C4.55038 9.91281 4.81739 10.1642 4.8178 10.4749C4.8178 10.7856 4.55119 11.0374 4.22168 11.0377H4.22087V12.7213C5.53646 12.7248 6.60613 11.7223 6.60979 10.4818C6.61263 9.59332 6.05953 8.78674 5.19884 8.42439C5.57055 6.99144 7.10364 6.11446 8.62334 6.46495C9.89551 6.75842 10.7887 7.83629 10.7826 9.07103C10.7826 9.5608 10.531 11.0224 9.75186 12.419C9.37041 13.1001 8.93621 13.6358 8.45737 14.0031Z'
                  fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45245'>
                  <rect width='15.7895' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Understanding Your Needs',
        text: `We kick off our process with in-depth discussions to understand your business needs and the application's objectives.`
      },
      {
        id: 2,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='22' height='21' viewBox='0 0 22 21' fill='none'>
              <g clipPath='url(#clip0_384_45255)'>
                <path
                  d='M14.0302 14.5301V0.600586H0V19.316H9.21914L14.0302 14.5301ZM9.67254 16.7467V14.9835H11.4358L9.67254 16.7467ZM1.51134 2.11192H12.5189V13.4721H8.16121V17.8046H1.51134V2.11192Z'
                  fill='#8358FF' />
                <path
                  d='M21.1077 15.8149V0.5H16.0195V15.8149L18.5636 20.5L21.1077 15.8149ZM17.9591 16.1927H19.1681L18.5636 17.3262L17.9591 16.1927ZM17.5309 14.6814V4.3539H19.5964V14.6814H17.5309ZM19.5964 2.01134V2.84257H17.5309V2.01134H19.5964Z'
                  fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45255'>
                  <rect width='21.1083' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Designing the dApp',
        text: `Our skilled team crafts a design keeping user experience at the forefront, ensuring simplicity amidst the complexity of blockchain.`
      },
      {
        id: 3,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21' fill='none'>
              <g clipPath='url(#clip0_384_45265)'>
                <path
                  d='M18.0565 20.5H1.94354C0.871819 20.5 0 19.6282 0 18.5565V2.44354C0 1.37182 0.871819 0.5 1.94354 0.5H18.0588C19.1305 0.5 20.0023 1.37182 20.0023 2.44354V18.5627C19.9979 19.631 19.1249 20.5002 18.0565 20.5002V20.5ZM1.94354 2.35099C1.89519 2.35099 1.85099 2.39519 1.85099 2.44354V18.5565C1.85099 18.6048 1.89519 18.649 1.94354 18.649H18.0565C18.1055 18.649 18.1506 18.6048 18.1513 18.5558V2.44354C18.1513 2.39519 18.1071 2.35099 18.0588 2.35099H1.94354Z'
                  fill='#8358FF' />
                <path d='M19.0771 3.89062H0.925781V5.74162H19.0771V3.89062Z' fill='#8358FF' />
                <path
                  d='M7.69995 15.7557L3.89453 12.3476L7.69995 8.93945L8.93502 10.3184L6.66917 12.3476L8.93502 14.3768L7.69995 15.7557Z'
                  fill='#8358FF' />
                <path
                  d='M12.3015 15.7557L11.0664 14.3768L13.3323 12.3476L11.0664 10.3184L12.3015 8.93945L16.1069 12.3476L12.3015 15.7557Z'
                  fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45265'>
                  <rect width='20.0023' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Developing the dApp',
        text: `We leverage the power of blockchain protocols like Ethereum, Binance Smart Chain, or others to develop a secure and efficient dApp.`
      },
      {
        id: 4,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='21' viewBox='0 0 20 21' fill='none'>
              <g clipPath='url(#clip0_384_45277)'>
                <path
                  d='M8.17107 4.55608C7.44053 4.21322 6.64726 4.02947 5.84053 4.01827C3.11336 3.89053 0.796275 5.99698 0.664062 8.72415V9.39642L4.54081 9.57569C3.97611 10.7746 3.56378 12.0407 3.30832 13.3404C3.12905 14.2143 3.80132 15.2676 4.496 15.9622C4.83213 16.2984 5.66126 17.0379 6.49039 17.0379H6.73689C8.11056 16.7959 9.44614 16.3656 10.7033 15.7606L10.8825 19.6597H11.5548C14.282 19.5275 16.3884 17.2104 16.2607 14.4833C16.2517 13.6833 16.068 12.8967 15.7229 12.1751C18.412 9.28437 19.8237 5.54208 19.8237 1.17233V0.500058H19.1515C14.7817 0.45524 11.0394 1.86701 8.17107 4.55608ZM18.2551 3.99586C17.361 3.62835 16.6506 2.91799 16.2831 2.02387C17.0092 1.90286 17.7442 1.82667 18.4792 1.79978C18.4523 2.53479 18.3761 3.26981 18.2551 3.99586ZM12.1823 13.3628L11.5548 13.7662C9.04726 13.188 7.09095 11.2317 6.5128 8.72415L6.89375 8.14151C8.88815 5.16112 11.622 3.18913 14.961 2.31518C15.4495 3.72247 16.5565 4.82947 17.9638 5.31799C17.1033 8.62555 15.0439 11.4939 12.1823 13.3628ZM2.09824 8.11911C2.51952 6.44964 4.0523 5.30006 5.77331 5.3628C6.24389 5.37849 6.71 5.45468 7.16266 5.58689C6.65622 6.15832 6.19235 6.7656 5.77331 7.40202C5.57387 7.67989 5.39235 7.97121 5.23549 8.27597L2.09824 8.11911ZM6.49039 15.6933C6.35594 15.7157 5.84053 15.4692 5.30272 14.8866C4.7649 14.304 4.58563 13.7438 4.60804 13.6093C4.83437 12.4956 5.18619 11.4132 5.66126 10.3824C6.47695 12.2917 7.99179 13.8155 9.89655 14.6401C8.80524 15.1174 7.66238 15.4715 6.49039 15.6933ZM12.1599 18.1807L12.0254 15.2452H12.0702L12.115 14.9987C12.384 14.8194 12.6753 14.6625 12.9442 14.4608C13.5582 14.0552 14.1431 13.6071 14.6921 13.1163C14.8355 13.5667 14.9117 14.0351 14.9162 14.5057C14.9879 16.2312 13.8361 17.7662 12.1599 18.1807Z'
                  fill='#8358FF' />
                <path
                  d='M14.894 5.38528C13.7175 4.20881 11.8127 4.20881 10.6363 5.38528C9.45979 6.56175 9.45979 8.46652 10.6363 9.64299C11.7881 10.8195 13.6749 10.8374 14.8514 9.68556C14.8648 9.67212 14.8805 9.65643 14.894 9.64299C16.0704 8.49116 16.0884 6.60433 14.9365 5.42786C14.9231 5.41441 14.9074 5.39873 14.894 5.38528ZM13.9528 8.70181C13.2738 9.33374 12.2094 9.29789 11.5774 8.6189C10.9769 7.97352 10.9769 6.97184 11.5774 6.32646C12.234 5.67212 13.2962 5.67212 13.9528 6.32646C14.6071 6.98304 14.6071 8.04523 13.9528 8.70181Z'
                  fill='#8358FF' />
                <path d='M3.58692 15.7529L0.148438 19.1914L1.09917 20.1421L4.53765 16.7037L3.58692 15.7529Z'
                      fill='#8358FF' />
                <path d='M5.22096 17.4275L3.09766 19.5508L4.04839 20.5015L6.17169 18.3782L5.22096 17.4275Z'
                      fill='#8358FF' />
                <path d='M1.90146 14.1073L0 16.0088L0.950732 16.9595L2.8522 15.0581L1.90146 14.1073Z' fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45277'>
                  <rect width='19.8252' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Testing',
        text: `Rigorous testing is done to ensure the application's robustness and security.`
      },
      {
        id: 5,
        icon: (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clipPath="url(#clip0_626_42543)">
                <path d="M16.9999 21.0005H6.99987C5.5831 21.0013 4.21172 20.5009 3.12856 19.5876C2.0454 18.6744 1.32035 17.4073 1.08178 16.0108C0.843215 14.6142 1.10653 13.1783 1.82511 11.9573C2.54368 10.7363 3.67115 9.80893 5.00787 9.33945C4.96259 8.39311 5.10989 7.44743 5.44083 6.55969C5.77178 5.67194 6.2795 4.86062 6.93322 4.17487C7.58694 3.48912 8.37307 2.94321 9.24398 2.57021C10.1149 2.19721 11.0525 2.00488 11.9999 2.00488C12.9473 2.00488 13.8849 2.19721 14.7558 2.57021C15.6267 2.94321 16.4128 3.48912 17.0665 4.17487C17.7203 4.86062 18.228 5.67194 18.5589 6.55969C18.8899 7.44743 19.0372 8.39311 18.9919 9.33945C20.3286 9.80893 21.4561 10.7363 22.1746 11.9573C22.8932 13.1783 23.1565 14.6142 22.918 16.0108C22.6794 17.4073 21.9543 18.6744 20.8712 19.5876C19.788 20.5009 18.4166 21.0013 16.9999 21.0005ZM6.99987 19.0005H16.9999C17.5425 18.9995 18.0793 18.8881 18.5775 18.6731C19.0758 18.4581 19.5251 18.144 19.8981 17.7499C20.2711 17.3557 20.5599 16.8898 20.7472 16.3805C20.9344 15.8712 21.016 15.3291 20.9871 14.7872C20.9581 14.2453 20.8192 13.715 20.5789 13.2285C20.3385 12.742 20.0016 12.3095 19.5888 11.9573C19.1759 11.6051 18.6957 11.3406 18.1774 11.1799C17.6591 11.0192 17.1135 10.9656 16.5739 11.0225C16.9099 10.2613 17.0507 9.42835 16.9835 8.59905C16.9163 7.76975 16.6432 6.97032 16.189 6.27323C15.7348 5.57614 15.1138 5.00343 14.3823 4.60699C13.6508 4.21054 12.8319 4.00292 11.9999 4.00292C11.1679 4.00292 10.349 4.21054 9.61748 4.60699C8.88598 5.00343 8.26497 5.57614 7.81074 6.27323C7.35651 6.97032 7.08342 7.76975 7.01621 8.59905C6.94901 9.42835 7.08982 10.2613 7.42587 11.0225C6.88621 10.9656 6.34062 11.0192 5.82232 11.1799C5.30402 11.3406 4.82383 11.6051 4.41099 11.9573C3.99815 12.3095 3.66128 12.742 3.42089 13.2285C3.1805 13.715 3.04161 14.2453 3.01268 14.7872C2.98374 15.3291 3.06537 15.8712 3.25259 16.3805C3.4398 16.8898 3.7287 17.3557 4.10169 17.7499C4.47468 18.144 4.92396 18.4581 5.42221 18.6731C5.92045 18.8881 6.45723 18.9995 6.99987 19.0005Z" fill="#7444FF"/>
              </g>
              <defs>
                <clipPath id="clip0_626_42543">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Deployment',
        text: `Post testing, we assist in deploying the dApp on the desired blockchain.`
      },
      {
        id: 6,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21' fill='none'>
              <g clipPath='url(#clip0_384_45290)'>
                <path
                  d='M17.1354 20.0403C16.7498 20.0403 16.3881 19.89 16.1157 19.6198L6.55465 10.2244C5.80728 10.4161 5.02287 10.4292 4.26461 10.2636C3.34511 10.0609 2.50405 9.60119 1.8373 8.93227C1.16838 8.26334 0.708629 7.42446 0.505991 6.50714C0.309889 5.61379 0.364362 4.68557 0.665051 3.82054L1.00714 2.8335L3.60004 5.43076L5.09695 5.20633L5.32138 3.70942L2.72412 1.11652L3.70899 0.774426C4.57184 0.473737 5.50223 0.419264 6.39559 0.615366C7.31509 0.818004 8.15397 1.27775 8.82289 1.94668C9.49182 2.61561 9.95157 3.45449 10.1542 4.37399C10.3198 5.13007 10.3067 5.9123 10.1172 6.65748L12.0499 8.55531L19.6804 16.0529C20.2447 16.6173 20.2447 17.5324 19.6804 18.0968L18.1617 19.6155C17.885 19.89 17.5211 20.0403 17.1354 20.0403ZM6.90545 8.73616L17.0374 18.6916C17.0701 18.7243 17.1093 18.733 17.1354 18.733C17.1616 18.733 17.1986 18.7265 17.2335 18.6916L18.7522 17.1729C18.8067 17.1184 18.8067 17.0335 18.7544 16.979L11.1304 9.49007L8.62025 7.02572L8.75535 6.63569C9.21074 5.32835 8.87083 3.85105 7.8925 2.87272C7.17781 2.15803 6.22999 1.78544 5.25819 1.80723L6.70499 3.25185L6.24088 6.35679L3.13594 6.8209L1.69132 5.37411C1.66953 6.34372 2.04212 7.29155 2.75681 8.00841C3.73514 8.98674 5.21244 9.32447 6.51978 8.87126L6.90545 8.73616Z'
                  fill='#8358FF' />
                <path
                  d='M3.14635 20.5004C2.79554 20.5004 2.44256 20.3675 2.17673 20.0995L0.403098 18.3259C0.143808 18.0666 0 17.7201 0 17.3519C0 16.9836 0.143808 16.6372 0.403098 16.3779L4.96792 11.8131C4.99188 11.7891 5.01585 11.7695 5.02893 11.7586C5.47342 11.3686 6.13145 11.3446 6.6021 11.702C6.60863 11.7063 6.61735 11.7129 6.62825 11.7216C6.63696 11.7281 6.64786 11.7368 6.66093 11.7477C6.67836 11.7608 6.70669 11.7826 6.73719 11.8131L8.69167 13.7676C8.72218 13.7981 8.74397 13.8264 8.75922 13.8438C8.77229 13.8613 8.78319 13.8765 8.79408 13.8896L8.79626 13.8918C9.16232 14.369 9.13835 15.0379 8.73525 15.4867L8.73307 15.4889C8.71782 15.5042 8.70475 15.5194 8.68949 15.5347L4.11596 20.0995C3.85013 20.3675 3.49715 20.5004 3.14635 20.5004ZM5.85255 12.7784L1.32696 17.3039C1.3117 17.3192 1.30735 17.3388 1.30735 17.3519C1.30735 17.365 1.3117 17.3846 1.32696 17.3998L3.10059 19.1735C3.12674 19.1996 3.16814 19.1996 3.1921 19.1735L7.71988 14.6457L5.85255 12.7784Z'
                  fill='#8358FF' />
                <path d='M15.7344 3.96684L11.125 8.55859L12.0477 9.4848L16.6571 4.89304L15.7344 3.96684Z'
                      fill='#8358FF' />
                <path d='M8.48154 11.1915L6.83203 12.833L7.7542 13.7597L9.40371 12.1182L8.48154 11.1915Z'
                      fill='#8358FF' />
                <path
                  d='M17.6599 5.36719L16.1477 5.30618L15.25 4.40847L15.2827 2.95295L17.8582 1.13574L19.4923 2.76992L17.6599 5.36719ZM16.712 4.02062L17.0018 4.03151L17.7884 2.91591L17.7122 2.83965L16.5748 3.64149L16.5704 3.87899L16.712 4.02062Z'
                  fill='#8358FF' />
                <path d='M6.00178 13.6222L2.14844 17.4756L3.07287 18.4L6.92622 14.5467L6.00178 13.6222Z' fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45290'>
                  <rect width='20.1033' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Support & Maintenance',
        text: `Our job doesn't end at deployment. We offer continuous support and maintenance to ensure smooth operations.`
      }
    ]
  };
  const drawerItems = [
    {
      title: 'Finance',
      desc: 'Decentralized finance (DeFi) applications are disrupting the financial sector, providing open, transparent, and secure financial services.',
      img: '/images/card-drawer/dapp/item-01.svg',
      id: 1
    },
    {
      title: 'Supply Chain',
      desc: 'dApps are enhancing traceability, ensuring product authenticity, and reducing fraud in supply chains.',
      img: '/images/card-drawer/dapp/item-02.svg',
      id: 2
    },
    {
      title: 'Gaming',
      desc: 'Blockchain-powered games or NFT games provide unique ownership rights and value realization to gamers.',
      img: '/images/card-drawer/dapp/item-03.svg',
      id: 3
    },
    {
      title: 'Healthcare',
      desc: 'dApps enhance data privacy, enable secure patient data sharing, and foster drug traceability in healthcare.',
      img: '/images/card-drawer/dapp/item-04.svg',
      id: 4
    },
    {
      title: 'Real Estate',
      desc: 'Decentralized platforms democratize real estate investments and ensure transparent property transactions.',
      img: '/images/card-drawer/dapp/item-05.svg',
      id: 5
    },
    {
      title: 'Art & Entertainment',
      desc: 'NFT platforms are transforming the digital art and entertainment industry, providing artists with new ways to monetize their work.',
      img: '/images/card-drawer/dapp/item-06.svg',
      id: 6
    },
  ];
  const servicesData = [
    {
      title: 'Secure Transactions',
      desc: "With cryptography at its core, blockchain ensures the utmost security for transactions.",
      id: '1',
      icon: '/images/services/dapp/services-01.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'Robust & Reliable',
      desc: "dApps, being based on blockchain, are resistant to single points of failure, providing enhanced reliability.",
      id: '2',
      icon: '/images/services/dapp/services-02.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'Transparent & Trustworthy',
      desc: "dApps ensure every transaction is recorded on a public ledger, boosting trust among users.",
      id: '3',
      icon: '/images/services/dapp/services-03.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'Reduced Costs',
      desc: "By eliminating intermediaries, dApps cut down operational costs.",
      id: '4',
      icon: '/images/services/dapp/services-04.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'User Empowerment',
      desc: "dApps give power back to the users, fostering a democratic digital ecosystem.",
      id: '5',
      icon: '/images/services/dapp/services-05.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
    {
      title: 'Innovation & Future-Readiness',
      desc: "dApps position your business at the forefront of digital innovation, helping you lead in the Web 3 world.",
      id: '6',
      icon: '/images/services/dapp/services-06.svg',
      itemClass: 'col-span-12 md:col-span-6 lg:col-span-4'
    },
  ];
  const benefitsData = [
    {
      id: '1',
      title: 'NFT Marketplaces',
      description: 'We build secure, user-friendly, and customizable NFT marketplaces that support the trading of various digital assets.',
      icon: '/images/services/dapp/benefits-01.svg',
      animationImage: '/images/token-tool/tokentool-side.png'
    },
    {
      id: '2',
      title: 'DeFi Lending & Borrowing Platforms',
      description: 'Our team develops platforms that enable peer-to-peer transactions, eliminating intermediaries and maximizing profitability.',
      icon: '/images/services/dapp/benefits-02.svg',
      animationImage: '/images/token-tool/tokentool-side.png'
    },
    {
      id: '3',
      title: 'Decentralized Exchanges (DEXs)',
      description: 'We design exchanges to facilitate direct crypto trades, ensuring complete anonymity and security.',
      icon: '/images/services/dapp/benefits-03.svg',
      animationImage: '/images/token-tool/tokentool-side.png'
    },
    {
      id: '4',
      title: 'Yield Farming Platforms',
      description: 'Our dApps encourage users to generate passive income through liquidity provision.',
      icon: '/images/services/dapp/benefits-04.svg',
      animationImage: '/images/token-tool/tokentool-side.png'
    },
    {
      id: '5',
      title: 'Staking Platforms',
      description: 'We create applications that reward users for their participation in network security.',
      icon: '/images/services/dapp/benefits-05.svg',
      animationImage: '/images/token-tool/tokentool-side.png'
    },
    {
      id: '6',
      title: 'Insurance Platforms',
      description: 'We design decentralized insurance platforms that democratize the access and availability of policy schemes.',
      icon: '/images/services/dapp/benefits-06.svg',
      animationImage: '/images/token-tool/tokentool-side.png'
    }
  ];

  return (
    <div>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <Hero_10 content={content} />
      <Features featuresContent={descList} image={"/images/features/dapp-reason.png"}/>
      <Services
        title={`Decentralize and Dominate: <br/>Benefits of dApp Development for Your Business`}
        servicesData={servicesData}
      />
      <Benifits
        title={'Alchemis: Your Trusted Decentralized App Development Partner'}
        subTitle={'At Alchemis, we specialize in developing cutting-edge decentralized applications (dApps) that empower businesses to leverage the potential of the Web 3 world. Our expertise spans:'}
        benefitsData={benefitsData}
      />
      <CardDrawer
        title={'Expanding Horizons: Use Cases of dApp Development'}
        subTitle={'dApp development is revolutionizing various industry sectors. Here are some of the key areas where our services can bring a transformative change:'}
        drawerItems={drawerItems} />
      <Features title={'Crafting Excellence: Our dApp Development Process'} subTitle={'At Alchemis, we have mastered the art of dApp development. Our process is as follows:'}
                featuresContent={features_data} />
      <FeaturesCard
        title={'Why Alchemis?'}
        subTitle={'Our technical prowess spans a multitude of blockchain platforms, allowing us to deliver solutions tailored to your business needs:'}
      />
      <CallToActions
        title={"Join us in revolutionizing the digital space with decentralized app development."}
        background={"/images/cta.png"}
        description={"Contact us today to see how our Web3 solution will help you realise your full business potential!"}
        btnText={"Start Now"}
        link={"/contact"}
      />
    </div>
  );
}

export default DappDevelopment;
